module.exports = __webpack_public_path__ + "img/about-bg2-m.1a1cb22e.png";